import React from 'react';

import {
  LegacyText,
  TableCell,
  TableRow,
  Tooltip,
  Stack,
} from '@gogame/components';

import { LogLinkToTracker } from 'scenes/SmartRules/components/LogLinkToTracker';

import ActionMetricsBlock from './ActionMetricsBlock';
import {
  Img,
  SpanAffectedLevel,
  StackConstStyled,
  TextActionDimensionName,
  ImgHolder,
} from './styled';

const LINE_CLAMP_SIZE = 2;

const InfoRow = ({
  secondaryAffectedLevel,
  totalRowSpan,
  affectedLevelName,
  thumbnailUrl,
  labelName,
  actionDimensionName,
  ruleLogId,
  affectedLevelId,
  actionMetricsValues,
}) => {
  return (
    <TableRow>
      {secondaryAffectedLevel ? (
        <TableCell rowSpan={totalRowSpan}>
          <Tooltip title={affectedLevelName} wrapper wrapperComponent={'div'}>
            <SpanAffectedLevel size={'13px'} ellipsis={true}>
              {affectedLevelName}
            </SpanAffectedLevel>
          </Tooltip>
        </TableCell>
      ) : null}
      <TableCell rowSpan={totalRowSpan}>
        <Stack direction={'row'} alignItems={'center'}>
          {thumbnailUrl ? (
            <ImgHolder>
              <Img src={thumbnailUrl} />
            </ImgHolder>
          ) : null}

          <StackConstStyled>
            <Tooltip title={labelName} wrapper wrapperComponent={'div'}>
              <LegacyText
                ellipsis={true}
                lineClamp={LINE_CLAMP_SIZE}
                wordBreak={'break-all'}
                size={'10px'}
                intensity={200}
              >
                {labelName}
              </LegacyText>
            </Tooltip>
            <Tooltip
              title={actionDimensionName}
              wrapper
              wrapperComponent={'div'}
            >
              <TextActionDimensionName
                ellipsis={true}
                lineClamp={LINE_CLAMP_SIZE}
                wordBreak={'break-all'}
              >
                <LogLinkToTracker
                  logId={ruleLogId}
                  affectedDimension={affectedLevelId}
                  affectedSecondaryDimension={secondaryAffectedLevel?.id}
                >
                  {actionDimensionName}
                </LogLinkToTracker>
              </TextActionDimensionName>
            </Tooltip>
          </StackConstStyled>
        </Stack>
      </TableCell>

      <ActionMetricsBlock
        actionMetricsValues={actionMetricsValues}
        totalRowSpan={totalRowSpan}
      />
    </TableRow>
  );
};

export default InfoRow;
